import React, { FC } from "react";
import { ToolbarProps } from "@material-ui/core/Toolbar";
import { StyledMuiToolbar } from './styles';

const Toolbar: FC<ToolbarProps> = (props) => {
  return (
    <StyledMuiToolbar {...props} />
  );
};

export default Toolbar;
